import React, { SVGProps } from 'react'
const SvgAlertCircledFilled2 = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#1B2C4F'}
      fillRule="evenodd"
      d="M18 3.375c8.077 0 14.625 6.548 14.625 14.625S26.077 32.625 18 32.625 3.375 26.077 3.375 18 9.923 3.375 18 3.375Zm0 6.015c.565 0 1.032.416 1.113.959l.012.166v10.762a1.125 1.125 0 0 1-2.238.166l-.012-.166V10.515c0-.622.504-1.125 1.125-1.125Zm1.113 15.947a1.125 1.125 0 0 0-2.238.166v.635l.012.166a1.125 1.125 0 0 0 2.238-.166v-.635l-.012-.166Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgAlertCircledFilled2
